import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { isArrayEqual, isMobile } from '../../utils';

import { setCurrentItem } from '../../actions/currentItem';
import { setInitialActiveChannel as setInitialActiveChannelAction } from '../../actions/nav';

import DesktopCamGroupCarousel from './DesktopCamGroupCarousel';
import MobileCamGroupCarousel from './MobileCamGroupCarousel';

import './styles.scss';

class CamGroupCarousel extends Component {

  state = {
    slides: [],
    viewportWidth: window.innerWidth,
  }

  componentWillMount() {
    this.prepareSlideItems(this.props);
    this.updateWindowDimensions();
    const { navChannelId, activeCamGroupId, channels, setInitialActiveChannel} = this.props;
    if (!navChannelId && activeCamGroupId ) {
      const activeChannel = channels.find((channel) => {
        return channel.cam_groups.includes(activeCamGroupId);
      });
      if (activeChannel) {
        setInitialActiveChannel(activeChannel.id);
      }
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  componentWillReceiveProps(nextProps) {
    const { navChannelId, activeCamGroupId, channels, setInitialActiveChannel} = nextProps;
    if (!isArrayEqual(Object.values(this.props.camGroups), Object.values(nextProps.camGroups))) {
      this.prepareSlideItems(nextProps);
    }
    if (!navChannelId && activeCamGroupId ) {
      const activeChannel = channels.find((channel) => {
        return channel.cam_groups.includes(activeCamGroupId);
      });
      if (activeChannel) {
        setInitialActiveChannel(activeChannel.id);
      }
    }
  }

  updateWindowDimensions = () => {
    this.setState({ viewportWidth: window.innerWidth });
  }

  prepareSlideItems = (props) => {
    const { camGroups: camGroupData, channels } = props;
    const camGroups = {};
    camGroupData.forEach((obj) => {
      camGroups[obj.id] = obj;
    }, {});

    const slides = channels.reduce((outputArray, channelData) => {
      let initialCamgroup = true;
      const groups = channelData.cam_groups ? channelData.cam_groups.map((id, index) => {
        const camGroup = camGroups[id];
        if (!camGroup) return null;
        if (camGroup.user || !camGroup.feed_count || !camGroup.feed_count > 0) {
          return null;
        }
        const isInitial = initialCamgroup;
        initialCamgroup = false;

        return {
          url: camGroup.multi_livecam ?
            `/livecams/${camGroup.slug}` :
            `/livecams/${camGroup.slug}/${camGroup.feeds[0].slug}`,
          camgroupId: camGroup.id,
          channelId: channelData.id,
          channelIds: camGroup.channel_ids,
          feedCount: camGroup.feed_count,
          imageUrl: camGroup.poster_url,
          description: camGroup.description,
          continuedDescription: camGroup.continued_description,
          feedId: null,
          title: camGroup.title,
          carouselChannelId: channelData.id,
          isInitialChannelCamgroup: isInitial,
        };
      }).filter(obj => obj) : [];
      return outputArray.concat(groups);
    }, []).filter(obj => obj); // Filter out null values;
    this.setState({ ...this.state, slides });
  }

  render() {
    const { slides, viewportWidth } = this.state;
    const { activeCamGroupId, activeFeedId, navChannelId, setCurrentItem, camGroups } = this.props;
    return isMobile.any || viewportWidth < 1024 ?
      <MobileCamGroupCarousel
        slides={slides}
        activeCamGroupId={activeCamGroupId}
        activeFeedId={activeFeedId}
        navChannelId={navChannelId}
        setCurrentItem={setCurrentItem}
        camGroups={camGroups}
      />
      :
      <DesktopCamGroupCarousel
        slides={slides}
        activeCamGroupId={activeCamGroupId}
        navChannelId={navChannelId}
      />;
  }

}

const defaultProps = {
  promos: [],
};

CamGroupCarousel.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const { data } = state.cam_groups;

  return {
    channels: state.channels.data || [],
    camGroups: data || [],
    activeCamGroupId: state.currentItem.data.cam_group.id,
    activeFeedId: state.currentItem.data.id,
    navChannelId: state.nav.channelId,
  };
}

export default connect(mapStateToProps, { setCurrentItem, setInitialActiveChannel: setInitialActiveChannelAction })(CamGroupCarousel);
